import { render, staticRenderFns } from "./DamagedDelivery.vue?vue&type=template&id=6b6e40da&"
import script from "./DamagedDelivery.vue?vue&type=script&lang=js&"
export * from "./DamagedDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DamagedDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports